import script from "./MessageItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageItem.vue?vue&type=script&setup=true&lang=ts"

import "./MessageItem.vue?vue&type=style&index=0&id=2cf02018&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf02018"]])

export default __exports__